import React, { useState, useEffect } from "react";
import axios from "axios";
import { ENDPOINTS } from "../Helper/endpoints";
import "../CSS/GSTInvoice.css";
import Swal from "sweetalert2";
import Footer from "./Footer";

const getCookie = (cookieName) => {
  const cookies = document.cookie.split("; ");
  for (let cookie of cookies) {
    const [name, value] = cookie.split("=");
    if (name === cookieName) return decodeURIComponent(value);
  }
  return null;
};

const GSTInvoice = ({ setCurrentPage }) => {

  const [setBilledTo] = useState({
    businessName: "", gstin: "", address: "", city: "", postalCode: "",
    mobile: "", pan: "", email: "", aadhaar: "", accountHolderName: "", bankAccountNumber: "", ifscCode: "",
    bankName: "", branch: "", upiId: "",
  });

  const [vendors, setVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState("");
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [showHSNModal, setShowHSNModal] = useState(false);
  const [hsnSearchQuery, setHsnSearchQuery] = useState("");
  const [showAddHSN, setShowAddHSN] = useState(false);
  const [newHsnCode, setNewHsnCode] = useState("");
  const [newHsnDescription, setNewHsnDescription] = useState("");
  const [hsnList, setHsnList] = useState([
    { code: "999210", description: "Pre-primary education services" },
    { code: "999220", description: "Primary education services" },
    { code: "999231", description: "Secondary education services, general" },
    { code: "999232", description: "Secondary education services, technical and vocational" },
    { code: "999241", description: "Higher education services, general" },
    { code: "999242", description: "Higher education services, technical" },
    { code: "999243", description: "Higher education services, vocational" },
    { code: "999249", description: "Other higher education services" },
    { code: "999259", description: "Specialised education services" },
    { code: "999291", description: "Cultural education services" },
    { code: "999292", description: "Sports and recreation education services" },
    { code: "999293", description: "Commercial training and coaching services" },
    { code: "999294", description: "Other education and training services n.e.c." },
    { code: "999295", description: "Services involving conduct of examination for admission to educational institutions" },
    { code: "999299", description: "Other Educational support services" },
    { code: "999311", description: "Inpatient services" },
    { code: "999312", description: "Medical and dental services" },
    { code: "999313", description: "Childbirth and related services" },
    { code: "999314", description: "Nursing and Physiotherapeutic services" },
    { code: "999315", description: "Ambulance services" },
    { code: "999316", description: "Medical Laboratory and Diagnostic-imaging services" },
    { code: "999317", description: "Blood, sperm and organ bank services" },
    { code: "999319", description: "Other human health services including homeopathy, unani, ayurveda, naturopathy, acupuncture etc." },
    { code: "999321", description: "Residential health-care services other than by hospitals" },
    { code: "999322", description: "Residential care services for the elderly and persons with disabilities" },
    { code: "999331", description: "Residential care services for children suffering from mental retardation, mental health illnesses or substance abuse" },
    { code: "999332", description: "Other social services with accommodation for children" },
    { code: "999333", description: "Residential care services for adults suffering from mental retardation, mental health illnesses or substance abuse" },
    { code: "999334", description: "Other social services with accommodation for adults" },
    { code: "999341", description: "Vocational rehabilitation services" },
    { code: "999349", description: "Other social services without accommodation for the elderly and disabled n.e.c." },
    { code: "999351", description: "Child day-care services" },
    { code: "999352", description: "Guidance and counseling services n.e.c. related to children" },
    { code: "999353", description: "Welfare services without accommodation" },
    { code: "999359", description: "Other social services without accommodation n.e.c." },
    { code: "999411", description: "Sewerage and sewage treatment services" },
    { code: "999412", description: "Septic tank emptying and cleaning services" },
    { code: "999421", description: "Collection services of hazardous waste" },
    { code: "999422", description: "Collection services of non-hazardous recyclable materials" },
    { code: "999423", description: "General waste collection services, residential" },
    { code: "999424", description: "General waste collection services, other n.e.c." },
    { code: "999431", description: "Waste preparation, consolidation and storage services" },
    { code: "999432", description: "Hazardous waste treatment and disposal services" },
    { code: "999433", description: "Non-hazardous waste treatment and disposal services" },
    { code: "999441", description: "Site remediation and clean-up services" },
    { code: "999442", description: "Containment, control and monitoring services and other site remediation services" },
    { code: "999443", description: "Building remediation services" },
    { code: "999449", description: "Other remediation services n.e.c." },
    { code: "999451", description: "Sweeping and snow removal services" },
    { code: "999459", description: "Other sanitation services n.e.c." },
    { code: "999490", description: "Other environmental protection services n.e.c." },
    { code: "999511", description: "Services furnished by business and employers organizations" },
    { code: "999512", description: "Services furnished by professional organizations" },
    { code: "999520", description: "Services furnished by trade unions" },
    { code: "999591", description: "Religious services" },
    { code: "999592", description: "Services furnished by political organizations" },
    { code: "999593", description: "Services furnished by human rights organizations" },
    { code: "999594", description: "Cultural and recreational associations" },
    { code: "999595", description: "Services furnished by environmental advocacy groups" },
    { code: "999596", description: "Services provided by youth associations" },
    { code: "999597", description: "Other civic and social organizations" },
    { code: "999598", description: "Homeowners associations" },
    { code: "999599", description: "Services provided by other membership organizations n.e.c." },
    { code: "999800", description: "Domestic services both part time & full time" },
    { code: "999900", description: "Services provided by extraterritorial organizations and bodies" }
  ]);

  const [tdsPercentage, setTdsPercentage] = useState(0);
  const [tdsSection, setTdsSection] = useState("");
  const [users, setUsers] = useState([]);
  const [rows, setRows] = useState([
    {
      description: "", quantity: "", unit: "", gstRate: "", rate: "",
      amount: "",
    },]);
  const [totals, setTotals] = useState({ subtotal: 0, cgst: 0, sgst: 0, grandTotal: 0, });
  const [visibleFields, setVisibleFields] = useState({
    charges: false,
    TDS: false,
    advance: false,
    debitNote: false,
    retention: false,
    outstanding: false
  });
  const [formData, setFormData] = useState({
    vendorPid: "", userPid: "", invoice_no: "", invoice_date: "",
    projectName: "Steel", prDate: new Date().toISOString().split("T")[0], description: "", totalAmount: 0,
    netPayable: 0, cgst: 0, sgst: 0, advance: 0, roundOff: 0, TDS: 0, outstanding: 0, charges: 0, name: "",
    address: "", GSTIN: "", pan_card_no: "", aadhar_no: "", mobile: "", email: "", account_holder_name: "",
    account_number: "", IFSC_code: "", bank_name: "", branch: "", UPI_ID: "", reference: 0, Debit_note: 0,
    Retention: 0,
  });

  const getUserDataFromCookies = () => {
    const userSessionData = getCookie("userSession");
    if (userSessionData) {
      try {
        const parsedSessionData = JSON.parse(userSessionData);
        return {
          userPid: parsedSessionData.data.user_info.user_pid,
          organizationsPid: parsedSessionData.data.user_info.organizations_pid,
        };
      } catch (e) {
        console.error("Error parsing user info from cookie:", e);
        return { userPid: "", organizationsPid: "" };
      }
    }
    return { userPid: "", organizationsPid: "" };
  };

  useEffect(() => {
    const { userPid, organizationsPid } = getUserDataFromCookies();
    setFormData((prevFormData) => ({
      ...prevFormData, userPid, organizationsPid,
    }));
  }, []);

  const handleFormDataChange = (field, value) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  useEffect(() => {
    const { organizationsPid } = getUserDataFromCookies();
    if (organizationsPid) {
      axios.get(ENDPOINTS.VENDOR_INFO, {
        params: { organization_pid: organizationsPid },
      })
        .then((response) => { setVendors(response.data.data || []); })
        .catch((error) => { console.error("Error fetching vendors:", error); });
    } else { console.warn("organizations_pid is missing, cannot fetch vendor info."); }
  }, []);

  const handleVendorChange = (vendorPid) => {
    setSelectedVendor(vendorPid);
    setFormData((prevFormData) => ({ ...prevFormData, vendorPid }));
    axios.get(ENDPOINTS.FEATCH_VENDOR, { params: { vendor_pid: vendorPid } })
      .then((response) => {
        const vendorDetails = response.data.data;
        setFormData((prevFormData) => ({
          ...prevFormData, name: vendorDetails.name || "", address: vendorDetails.address || "",
          GSTIN: vendorDetails.GSTIN || "", pan_card_no: vendorDetails.pan_card_no || "",
          aadhar_no: vendorDetails.aadhar_no || "", mobile: vendorDetails.mobile || "",
          email: vendorDetails.email || "", account_holder_name: vendorDetails.account_holder_name || "",
          account_number: vendorDetails.account_number || "", IFSC_code: vendorDetails.IFSC_code || "",
          bank_name: vendorDetails.bank_name || "", branch: vendorDetails.branch || "", UPI_ID: vendorDetails.UPI_ID || "",
        }));
      })
      .catch((error) => {
        console.error("Error fetching vendor details:", error);
      });
  };

  useEffect(() => {
    const { organizationsPid } = getUserDataFromCookies();
    if (organizationsPid) {
      axios
        .get(ENDPOINTS.USER_INFO, {
          params: { organization_pid: organizationsPid },
        })
        .then((response) => {
          setUsers(response.data.data || []);
        })
        .catch((error) => {
          console.error("Error fetching users:", error);
        });
    } else {
      console.warn("Organization PID is missing, cannot fetch users.");
    }
  }, []);

  const handleInputChange = (e, section, field, index = null) => {
    const value = e.target ? e.target.value : e;
    if (section === "invoiceDetails") {
      if (index !== null) {
        setRows((prevRows) => {
          const newRows = [...prevRows];
          newRows[index] = { ...newRows[index], [field]: value };
          const quantity = parseFloat(newRows[index].quantity) || 0;
          const rate = parseFloat(newRows[index].rate) || 0;
          const gstRate = parseFloat(newRows[index].gstRate) || 0;
          const amount = quantity * rate;
          const totalGSTAmount = (amount * gstRate) / 100;
          const cgst = totalGSTAmount / 2;
          const sgst = totalGSTAmount / 2;
          const total = amount + cgst + sgst;
          newRows[index].amount = amount.toFixed(2);
          newRows[index] = {
            ...newRows[index],
            amount: amount.toFixed(2),
            cgst: cgst.toFixed(2),
            sgst: sgst.toFixed(2),
            total: total.toFixed(2),
          };
          calculateTotals(newRows);
          return newRows;
        });
      }
    } else if (section === "billedTo") {
      setBilledTo((prevBilledTo) => ({ ...prevBilledTo, [field]: value }));
    }
  };

  const addRow = () => {
    setRows([
      ...rows,
      {
        itemName: "", hsn: "", quantity: "", unit: "", gstRate: "", rate: "", amount: "0.00", cgst: "0.00",
        sgst: "0.00", total: "0.00",
      },]);
  };

  const removeRow = (index) => {
    if (rows.length === 1) {
      Swal.fire({
        icon: 'warning', text: 'At least one row required!',
        confirmButtonText: 'OK', customClass: { popup: 'small-swal-popup', },
      }); return;
    }
    const updatedRows = rows.filter((_, rowIndex) => rowIndex !== index);
    setRows(updatedRows);
    calculateTotals(updatedRows);
  };

  const calculateTotals = (rowsData, newTdsPercentage, otherCharges, advance, outstanding, debitNote, retention) => {
    const currentTdsPercentage = parseFloat(newTdsPercentage) || 0;
    const otherChargesValue = parseFloat(otherCharges) || 0;
    const advanceValue = parseFloat(advance) || 0;
    const outstandingValue = parseFloat(outstanding) || 0;
    const debitNoteValue = parseFloat(debitNote) || 0;
    const retentionValue = parseFloat(retention) || 0;

    const calculatedTotals = rowsData.reduce(
      (acc, row) => {
        const amount = parseFloat(row.amount) || 0;
        const cgst = parseFloat(row.cgst) || 0;
        const sgst = parseFloat(row.sgst) || 0;
        return {
          subtotal: acc.subtotal + amount,
          cgst: acc.cgst + cgst,
          sgst: acc.sgst + sgst,
        };
      },
      { subtotal: 0, cgst: 0, sgst: 0 }
    );

    const totalWithGST = calculatedTotals.subtotal + calculatedTotals.cgst + calculatedTotals.sgst;
    const totalWithCharges = totalWithGST + otherChargesValue;
    const tdsAmount = (totalWithCharges * currentTdsPercentage) / 100;
    const totalAfterTDS = totalWithCharges - tdsAmount;
    const totalAfterAdvance = totalAfterTDS - advanceValue;
    const totalAfterOutstanding = totalAfterAdvance - outstandingValue;
    const totalAfterDebitNote = totalAfterOutstanding - debitNoteValue;
    const totalBeforeRoundoff = totalAfterDebitNote - retentionValue;
    const roundOff = Math.round(totalBeforeRoundoff) - totalBeforeRoundoff;
    const netPayable = Math.round(totalBeforeRoundoff);

    setTotals({
      subtotal: calculatedTotals.subtotal,
      cgst: calculatedTotals.cgst,
      sgst: calculatedTotals.sgst,
      charges: otherChargesValue,
      TDS: tdsAmount.toFixed(2),
      advance: advanceValue,
      outstanding: outstandingValue,
      debitNote: debitNoteValue,
      retention: retentionValue,
      roundOff: roundOff.toFixed(2),
      netPayable: netPayable,
    });
  };

  const handleAddField = () => {
    Swal.fire({
      title: 'Select Additional Fields',
      html: `
          <div style="text-align: left; margin-bottom: 20px; width: 160px; margin: auto;">
            <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 15px;">
              <label for="charges" style="flex: 1;">Other Charges</label>
              <input type="checkbox" id="charges" ${visibleFields.charges ? 'checked' : ''} style="width: 20px; height: 20px;">
            </div>
            <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 15px;">
              <label for="TDS" style="flex: 1;">TDS</label>
              <input type="checkbox" id="TDS" ${visibleFields.TDS ? 'checked' : ''} style="width: 20px; height: 20px;">
            </div>
            <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 15px;">
              <label for="advance" style="flex: 1;">Advance</label>
              <input type="checkbox" id="advance" ${visibleFields.advance ? 'checked' : ''} style="width: 20px; height: 20px;">
            </div>
            <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 15px;">
              <label for="debitNote" style="flex: 1;">Debit Note</label>
              <input type="checkbox" id="debitNote" ${visibleFields.debitNote ? 'checked' : ''} style="width: 20px; height: 20px;">
            </div>
            <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 15px;">
              <label for="retention" style="flex: 1;">Retention</label>
              <input type="checkbox" id="retention" ${visibleFields.retention ? 'checked' : ''} style="width: 20px; height: 20px;">
            </div>
            <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 15px;">
              <label for="outstanding" style="flex: 1;">Outstanding</label>
              <input type="checkbox" id="outstanding" ${visibleFields.outstanding ? 'checked' : ''} style="width: 20px; height: 20px;">
            </div>
          </div>
        `,
      showCancelButton: true,
      confirmButtonText: 'Apply',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#191056',
      cancelButtonColor: '#191056',
      preConfirm: () => {
        return {
          charges: document.getElementById('charges').checked,
          TDS: document.getElementById('TDS').checked,
          advance: document.getElementById('advance').checked,
          debitNote: document.getElementById('debitNote').checked,
          retention: document.getElementById('retention').checked,
          outstanding: document.getElementById('outstanding').checked
        };
      }
    }).then((result) => {
      if (result.isConfirmed) {
        setVisibleFields(result.value);
      }
    });
  };

  const handleCreateInvoice = () => {
    try {
      if (!formData.organizationsPid || !selectedVendor || !formData.userPid) {
        throw new Error("Required fields are missing");
      }
      const descriptionData = rows.map((row) => {
        return {
          item: row.itemName || '',
          HSN_SAC: row.hsn || '',
          unit: row.unit || '',
          quantity: Number(row.quantity || 0),
          GST: Number(row.gstRate || 0),
          CGST: Number(row.cgst || 0),
          SGST: Number(row.sgst || 0),
          Amount: Number(row.amount || 0),
        };
      });

      const invoiceData = {
        organizations_pid: formData.organizationsPid,
        vendors_pid: selectedVendor,
        user_pid: formData.userPid,
        invoice_no: formData.invoice_no,
        project_name: formData.projectName,
        invoice_date: formData.invoice_date,
        pr_date: formData.prDate,
        total_amount: Number(totals.subtotal || 0).toFixed(2),
        net_payable: Number(totals.netPayable || 0).toFixed(2),
        CGST: Number(totals.cgst || 0).toFixed(2),
        SGST: Number(totals.sgst || 0).toFixed(2),
        round_off: Number(totals.roundOff || 0).toFixed(2),
        advance: Number(totals.advance || 0).toFixed(2),
        outstanding: Number(totals.outstanding || 0).toFixed(2),
        other_charges: Number(totals.charges || 0).toFixed(2),
        description: descriptionData,
        name: formData.name?.trim(),
        address: formData.address?.trim(),
        GSTIN: formData.GSTIN?.trim(),
        pan_card_no: formData.pan_card_no?.trim(),
        aadhar_no: formData.aadhar_no?.trim(),
        mobile: formData.mobile?.trim(),
        email: formData.email?.trim(),
        account_holder_name: formData.account_holder_name?.trim(),
        account_number: formData.account_number?.trim(),
        IFSC_code: formData.IFSC_code?.trim(),
        bank_name: formData.bank_name?.trim(),
        branch: formData.branch?.trim(),
        UPI_ID: formData.UPI_ID?.trim(),
        reference: formData.reference,
        TDS: Number(totals.TDS || 0).toFixed(2),
        TDS_percentage: Number(tdsPercentage).toFixed(2),
        HSN_SAC: "NA",
        Retention: Number(totals.retention || 0).toFixed(2),
        Debit_note: Number(totals.debitNote || 0).toFixed(2),
        TDS_section: tdsSection || 'NA',
        Created_by: formData.userPid,
        Checked_by: formData.Checked_by,
        Approved_by: formData.Approved_by,
      };

      const requiredFields = ["name", "GSTIN", "account_number", "IFSC_code"];
      const missingFields = requiredFields.filter((field) => !invoiceData[field]);
      if (missingFields.length > 0) {
        throw new Error(`Missing required fields: ${missingFields.join(", ")}`);
      }

      axios.post(ENDPOINTS.INVOICES, invoiceData)
        .then((response) => {
          return Swal.fire({
            icon: "success",
            title: "Payment Recommendation Created!",
            text: `Payment Recommendation #${response.data.invoice_id || ""} has been created successfully`,
            customClass: { popup: "small-swal-popup" },
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            setCurrentPage("PRList");
          });
        })
        .catch((error) => {
          console.error("Error creating invoice:", error);
          const errorMessage = error.response?.data?.message || error.message || "An unexpected error occurred";
          return Swal.fire({
            icon: "error",
            title: "Failed to Create Payment Recommendation",
            text: errorMessage,
            customClass: { popup: "small-swal-popup" },
            showConfirmButton: false,
            timer: 3000,
          });
        });
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: error.message,
        customClass: { popup: "small-swal-popup" },
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };

  const styles = {
    formGroup: {
      display: "flex", alignItems: "center", justifyContent: "space-between",
      gap: "15px", marginBottom: "15px", fontFamily: "'Ubuntu', sans-serif",
    },
    label: {
      width: "100%", fontWeight: 600, color: "#555",
      fontFamily: "'Ubuntu', sans-serif", textAlign: "right",
    },
    input: {
      width: "35%", padding: "0px", fontSize: "16px", border: "none",
      borderBottom: "2px solid #191056", background: "transparent", color: "#333",
      outline: "none", transition: "border-color 0.3s ease-in-out", fontFamily: "'Ubuntu', sans-serif",
    },
    inputFocus: { borderBottom: "2px solid #191056" },
    textarea: { height: "100px", resize: "none" },
    vendorInfo: { marginTop: "10px" },
    editButton: {
      marginTop: "10px", padding: "8px 12px", backgroundColor: "#191056",
      color: "#fff", border: "none", cursor: "pointer", fontFamily: "'Ubuntu', sans-serif",
    },
    submitButton: {
      display: "flex", justifyContent: "center", alignItems: "center", height: "100%", width: "100%",
    },
    TDSInput: {
      width: "24%", padding: "0px", fontSize: "16px", border: "none",
      borderBottom: "2px solid #191056", background: "transparent", color: "#333",
      outline: "none", transition: "border-color 0.3s ease-in-out", fontFamily: "'Ubuntu', sans-serif",
    },
    TDSPercentage: {
      width: "7%", padding: "0px", fontSize: "16px", border: "none",
      borderBottom: "2px solid #191056", background: "transparent", color: "#333",
      outline: "none", transition: "border-color 0.3s ease-in-out", fontFamily: "'Ubuntu', sans-serif",
    },
    addButton: {
      background: '#191056', color: 'white', border: 'none', borderRadius: '10%',
      width: '35px', height: '35px', fontSize: '26px', cursor: 'pointer',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'Ubuntu', sans-serif", marginLeft: 'auto',
    }
  };

  return (
    <>
      <div className="invoice-container">
        <h1 className="invoice-title">Payment Recommendation</h1>
        <div className="invoice-details">
          <div style={styles.formGroup}>
            <label style={styles.label}>Invoice No</label>
            <input type="text" placeholder="Enter Invoice No" value={formData.invoice_no}
              onChange={(e) => handleFormDataChange("invoice_no", e.target.value)}
              style={styles.input} />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Invoice Date</label>
            <input type="date" value={formData.invoice_date}
              onChange={(e) => handleFormDataChange("invoice_date", e.target.value)}
              style={styles.input} />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>PR Date</label>
            <input type="date" value={formData.prDate}
              onChange={(e) => handleInputChange(e, "invoiceDetails", "prDate")}
              style={styles.input} />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Reference</label>
            <input type="text" placeholder="Enter Reference" value={formData.reference}
              onChange={(e) => handleFormDataChange("reference", e.target.value)}
              style={styles.input} />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Checked By</label>
            <select value={formData.Checked_by}
              onChange={(e) => handleFormDataChange("Checked_by", e.target.value)}
              style={styles.input}>
              <option value="">Select User</option>
              {(users || []).map((user) => (
                <option key={user.user_pid} value={user.user_pid}>
                  {user.name}
                </option>
              ))}
            </select>
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Approved By</label>
            <select value={formData.Approved_by}
              onChange={(e) => handleFormDataChange("Approved_by", e.target.value)}
              style={styles.input}>
              <option value="">Select an approver</option>
              {(users || [])
                .filter(user => ["admin", "manager", "accountant"].includes(user.role?.toLowerCase()))
                .map(user => (
                  <option key={user.user_pid} value={user.user_pid}>
                    {user.name}
                  </option>
                ))}
            </select>
          </div>
        </div>

        <div className="billing-box">
          <h2>Billed To</h2>
          {!selectedVendor ? (
            <div style={styles.formGroup}>
              <select id="vendorSelect" value={selectedVendor}
                onChange={(e) => handleVendorChange(e.target.value)}
                style={styles.input}>
                <option value="">Select Vendor</option>
                {(vendors || []).map((vendor) => (
                  <option key={vendor.pid} value={vendor.pid}>
                    {vendor.name}
                  </option>
                ))}
              </select>
            </div>
          ) : (
            <div style={styles.vendorInfo} className="vendor-info">
              <p><strong>{formData.name}</strong></p>
              <table className="vendor-table">
                {formData.address && (
                  <tr><td>Address</td><td>:</td><td>{formData.address}</td></tr>
                )}
                {formData.GSTIN && (
                  <tr><td>GST</td><td>:</td><td>{formData.GSTIN}</td></tr>
                )}
                <tr><td>Phone no</td><td>:</td><td>{formData.mobile}</td></tr>
                {formData.email && (
                  <tr><td>Email Id</td><td>:</td><td>{formData.email}</td></tr>
                )}
              </table>
              <div className="change-vendor">
                <button onClick={() => setSelectedVendor("")}>Change Vendor</button>
              </div>
            </div>
          )}
        </div>

        {showHSNModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h3>Find SAC/HSN</h3>
              <input type="text" placeholder="Search SAC/HSN" value={hsnSearchQuery}
                onChange={(e) => setHsnSearchQuery(e.target.value)} />
              <div className="hsn-list">
                {hsnList
                  .filter((item) => item.description.toLowerCase().includes(hsnSearchQuery.toLowerCase()))
                  .map((item, idx) => (
                    <div key={idx} className="hsn-item"
                      onClick={() => {
                        const updatedRows = [...rows];
                        updatedRows[selectedRowIndex].hsn = item.code;
                        handleInputChange({ target: { value: item.code } }, "invoiceDetails", "hsn", selectedRowIndex);
                        setRows(updatedRows);
                        setShowHSNModal(false);
                        setHsnSearchQuery("");
                      }}>
                      {item.code} - {item.description}
                    </div>
                  ))}
                {hsnSearchQuery.length >= 3 &&
                  hsnList.filter((item) =>
                    item.description.toLowerCase().includes(hsnSearchQuery.toLowerCase())
                  ).length === 0 && (
                    <div>
                      <p>No results found</p>
                      <button onClick={() => setShowAddHSN(true)}>Add New HSN</button>
                    </div>
                  )}
              </div>
              {showAddHSN && (
                <div className="add-hsn">
                  <input type="text" placeholder="HSN Code" value={newHsnCode}
                    onChange={(e) => setNewHsnCode(e.target.value)} />
                  <input type="text" placeholder="HSN Description" value={newHsnDescription}
                    onChange={(e) => setNewHsnDescription(e.target.value)} />
                  <button onClick={() => {
                    if (newHsnCode && newHsnDescription) {
                      setHsnList([...hsnList, { code: newHsnCode, description: newHsnDescription }]);
                      const updatedRows = [...rows];
                      updatedRows[selectedRowIndex].hsn = newHsnCode;
                      handleInputChange({ target: { value: newHsnCode } }, "invoiceDetails", "hsn", selectedRowIndex);
                      setRows(updatedRows);
                      setShowHSNModal(false);
                      setShowAddHSN(false);
                      setNewHsnCode("");
                      setNewHsnDescription("");
                    }
                  }}>Save HSN</button>
                </div>
              )}
              <button onClick={() => setShowHSNModal(false)}>Close</button>
            </div>
          </div>
        )}

        <div className="items-section">
          <h2 className="left-aligned">Items</h2>
          <div className="item-header">
            <span>Item</span>
            <span>HSN/SAC</span>
            <span>GST</span>
            <span>Qty</span>
            <span>Rate</span>
            <span>Amount</span>
          </div>
          {(rows || []).map((row, index) => (
            <div className="item-row" key={index}>
              <textarea placeholder="Item Name" value={row.itemName}
                onChange={(e) => handleInputChange(e, "invoiceDetails", "itemName", index)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    const newValue = row.itemName + "\n";
                    handleInputChange({ target: { value: newValue } }, "invoiceDetails", "itemName", index);
                  }
                }}
                rows={1} style={{ resize: "none", width: "100%" }} />
              <input type="text" placeholder="HSN/SAC" value={row.hsn} readOnly
                onClick={() => { setSelectedRowIndex(index); setShowHSNModal(true); }} />
              <select value={row.gstRate}
                onChange={(e) => handleInputChange(e, "invoiceDetails", "gstRate", index)}>
                <option value="">Select GST</option>
                <option value="0">0%</option>
                <option value="5">5%</option>
                <option value="12">12%</option>
                <option value="18">18%</option>
                <option value="28">28%</option>
              </select>
              <input type="number" placeholder="Qty" value={row.quantity}
                onChange={(e) => handleInputChange(e, "invoiceDetails", "quantity", index)} />
              <input type="number" placeholder="Rate" value={row.rate}
                onChange={(e) => handleInputChange(e, "invoiceDetails", "rate", index)} />
              <input type="number" placeholder="Amount" value={row.amount} disabled />
            </div>
          ))}
          <div className="form-group" style={{ marginTop: '10px', display: 'flex', alignItems: 'center' }}>
            <button onClick={addRow} style={{ marginRight: '10px' }}>+</button>
            <button onClick={() => removeRow(rows.length - 1)}>-</button>
          </div>
        </div>

        <div className="total-section">
          <div className="total-section">
            <div className="totals-section">
              <div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Subtotal</label>
                  <input type="text" disabled value={totals.subtotal ? totals.subtotal : "00"} style={styles.input} />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>CGST</label>
                  <input type="text" disabled value={totals.cgst ? totals.cgst.toFixed(2) : "00"} style={styles.input} />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>SGST</label>
                  <input type="text" disabled value={totals.sgst ? totals.sgst.toFixed(2) : "00"} style={styles.input} />
                </div>

                {visibleFields.charges && (
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Other Charges</label>
                    <input type="text" value={totals.charges || "00"}
                      onChange={(e) => {
                        const value = parseFloat(e.target.value) || 0;
                        setTotals((prevTotals) => ({ ...prevTotals, charges: value }));
                        calculateTotals(rows, tdsPercentage, value, totals.advance, totals.outstanding);
                      }}
                      style={styles.input} />
                  </div>
                )}

                {visibleFields.TDS && (
                  <div style={{ display: "flex", flexDirection: "column", gap: "5px", marginBottom: "15px", fontFamily: "Ubuntu, sans-serif", width: "100%" }}>
                    <div style={styles.formGroup}>
                      <label style={{ width: "290%", fontWeight: 600, color: "#555", fontFamily: "'Ubuntu', sans-serif", textAlign: "right" }}>TDS</label>
                      <select value={tdsPercentage}
                        onChange={(e) => {
                          const value = parseFloat(e.target.value) || 0;
                          setTdsPercentage(value);
                          let section = "";
                          if (value === 5) section = "Section 194H - Commission or Brokerage";
                          else if (value === 3.75) section = "Section 194H - Commission or Brokerage (Reduced)";
                          else if (value === 10) section = "Section 194 - Dividend";
                          else if (value === 7.5) section = "Section 194 - Dividend (Reduced)";
                          else if (value === 15) section = "Section 194A - Other Interest than securities";
                          else if (value === 2) section = "Section 194C - Payment of contractors for Others";
                          else if (value === 1.5) section = "Section 194C - Payment of contractors for Others (Reduced)";
                          else if (value === 1) section = "Section 194C - Payment of contractors HUF/Individual";
                          else if (value === 0.75) section = "Section 194C - Payment of contractors HUF/Individual (Reduced)";
                          setTdsSection(section);
                          const tdsAmount = totals.subtotal ? (totals.subtotal * value) / 100 : 0;
                          setTotals((prevTotals) => ({ ...prevTotals, TDS: tdsAmount }));
                          calculateTotals(rows, value, totals.charges, totals.advance, totals.outstanding);
                        }}
                        style={{ width: "100%", padding: "8px", fontSize: "inherit", border: "none", borderBottom: "2px solid #191056", background: "transparent", color: "#333", outline: "none", transition: "border-color 0.3s ease-in-out", fontFamily: "'Ubuntu', sans-serif", height: "auto" }}>
                        <option value="">TDS%</option>
                        <option value="5">5%</option>
                        <option value="3.75">3.75%</option>
                        <option value="7.5">7.5%</option>
                        <option value="10">10%</option>
                        <option value="15">15%</option>
                        <option value="2">2%</option>
                        <option value="1.5">1.5%</option>
                        <option value="1">1%</option>
                        <option value="0.75">0.75%</option>
                      </select>
                    </div>
                    <div style={styles.formGroup}>
                      <label style={{ width: "290%", fontWeight: 600, color: "#555", fontFamily: "'Ubuntu', sans-serif", textAlign: "right" }}>TDS Section</label>
                      <select value={tdsSection} onChange={(e) => setTdsSection(e.target.value)}
                        style={{ width: "100%", padding: "8px", fontSize: "inherit", border: "none", borderBottom: "2px solid #191056", background: "transparent", color: "#333", outline: "none", transition: "border-color 0.3s ease-in-out", fontFamily: "'Ubuntu', sans-serif", height: "auto" }}>
                        <option value="">Select Section</option>
                        <option value="Section 194H - Commission or Brokerage">Section 194H - Commission or Brokerage</option>
                        <option value="Section 194H - Commission or Brokerage (Reduced)">Section 194H - Commission or Brokerage (Reduced)</option>
                        <option value="Section 194 - Dividend">Section 194 - Dividend</option>
                        <option value="Section 194 - Dividend (Reduced)">Section 194 - Dividend (Reduced)</option>
                        <option value="Section 194A - Other Interest than securities">Section 194A - Other Interest than securities</option>
                        <option value="Section 194C - Payment of contractors for Others">Section 194C - Payment of contractors for Others</option>
                        <option value="Section 194C - Payment of contractors HUF/Individual">Section 194C - Payment of contractors HUF/Individual</option>
                      </select>
                    </div>
                    <div style={styles.formGroup}>
                      <label style={{ width: "290%", fontWeight: 600, color: "#555", fontFamily: "'Ubuntu', sans-serif", textAlign: "right" }}>TDS Amount</label>
                      <input type="text" disabled value={(Number(totals.TDS) || 0).toFixed(2)}
                        style={{ width: "100%", padding: "8px", fontSize: "inherit", border: "none", borderBottom: "2px solid #191056", background: "transparent", color: "#333", outline: "none", transition: "border-color 0.3s ease-in-out", fontFamily: "'Ubuntu', sans-serif", height: "auto" }} />
                    </div>
                  </div>
                )}

                {visibleFields.advance && (
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Advance</label>
                    <input type="text" value={totals.advance || 0}
                      onChange={(e) => {
                        const value = parseFloat(e.target.value) || 0;
                        setTotals((prevTotals) => {
                          const updatedTotals = { ...prevTotals, advance: value };
                          calculateTotals(rows, tdsPercentage, updatedTotals.charges, updatedTotals.advance, updatedTotals.outstanding);
                          return updatedTotals;
                        });
                      }}
                      style={styles.input} />
                  </div>
                )}

                {visibleFields.debitNote && (
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Debit Note</label>
                    <input type="text" value={totals.debitNote || 0}
                      onChange={(e) => {
                        const value = parseFloat(e.target.value) || 0;
                        setTotals((prevTotals) => {
                          const updatedTotals = { ...prevTotals, debitNote: value };
                          calculateTotals(rows, tdsPercentage, updatedTotals.charges, updatedTotals.advance, updatedTotals.outstanding, updatedTotals.debitNote, updatedTotals.retention);
                          return updatedTotals;
                        });
                      }}
                      style={styles.input} />
                  </div>
                )}

                {visibleFields.retention && (
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Retention</label>
                    <input type="text" value={totals.retention || 0}
                      onChange={(e) => {
                        const value = parseFloat(e.target.value) || 0;
                        setTotals((prevTotals) => {
                          const updatedTotals = { ...prevTotals, retention: value };
                          calculateTotals(rows, tdsPercentage, updatedTotals.charges, updatedTotals.advance, updatedTotals.outstanding, updatedTotals.debitNote, updatedTotals.retention);
                          return updatedTotals;
                        });
                      }}
                      style={styles.input} />
                  </div>
                )}

                {visibleFields.outstanding && (
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Outstanding</label>
                    <input type="text" value={totals.outstanding || "00"}
                      onChange={(e) => {
                        const value = parseFloat(e.target.value) || 0;
                        setTotals((prevTotals) => ({ ...prevTotals, outstanding: value }));
                        calculateTotals(rows, tdsPercentage, totals.charges, totals.advance, value);
                      }}
                      style={styles.input} />
                  </div>
                )}

                <div style={styles.formGroup}>
                  <label style={styles.label}>Net Payable</label>
                  <input type="text" disabled
                    value={totals.netPayable ? totals.netPayable.toFixed(2) : "00"}
                    style={styles.input} />
                </div>
                <button style={styles.addButton} onClick={handleAddField} title="Add additional fields">+</button>
              </div>
            </div>
          </div>
        </div>

        <div className="" style={styles.submitButton}>
          <button className="submit-btn-invoice" onClick={handleCreateInvoice}>Submit</button>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default GSTInvoice;